module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-10.png?39d430b5";